import React from "react";

export const Notifications = React.createContext({
  notifications: [],
  reloadNotifications: null,
  deleteNotification: null,
  readNotification: null,
});
